export const FETCH_SUBMISSION_REQUESTS = 'dashboard/FETCH_SUBMISSION_REQUESTS';
export const FETCH_ORGANISATION_CLIENTS =
  'dashboard/FETCH_ORGANISATION_CLIENTS';
export const DOWNLOAD_AUTHORIZATION_LETTER =
  'dashboard/DOWNLOAD_AUTHORIZATION_LETTER';
export const DOWNLOAD_SUBMISSION_REQUESTS =
  'dashboard/DOWNLOAD_SUBMISSION_REQUESTS';
export const FETCH_SUBMISSION_REQUESTS_URL =
  'dashboard/FETCH_SUBMISSION_REQUESTS_URL';
export const SEARCH_FOR_SUBMISSION_REQUESTS =
  'dashboard/SEARCH_FOR_SUBMISSION_REQUESTS';
export const AUTO_MATCH_SUBMISSIONS = 'dashboard/AUTO_MATCH_SUBMISSION';
